import {LuChevronDown} from "@/Components/Icons/Icons"
export default {
  row1:[
  {
    column: "column1",
    columnWidth: "40%",
    rows: {
      row1: [
        {
          name: "submittedBy",    // ✅ backend key
          label: "Submitted By",
          component: "dropdown",
          value: "tripath",
          options: [
            { label: "TRIPATH LOGISTICS PVT LTD", value: "tripath" },
            { label: "Self", value: "self" },
          ],
          endIconName: "LuChevronDown",

        },
      ],
      row2: [
        {
          name: "sezUnitCode",    // ✅ backend key
          label: "SEZ Unit Code",
          component: "text-field",
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
        },
      ],
      row3: [
        {
          name: "drawbackBeneficiary", // ✅ backend key
          label: "Drawback Beneficiary",
          component: "dropdown",
          value: "iec",
          options: [
            { label: "IEC", value: "iec" },
            { label: "SEZ", value: "sez" },
          ],
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
        },
      ],
    },
  },
]
};
